// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs__3h-uf","breadcrumb__level-indicator":"breadcrumbs_breadcrumb__level-indicator__XS3ZA"};